"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("./dom");
var keyboard_1 = require("./keyboard");
exports.IsFocusVisibleClassName = 'ms-Fabric--isFocusVisible';
/**
 * Initializes the logic which:
 *
 * 1. Subscribes keydown and mousedown events. (It will only do it once per window,
 *    so it's safe to call this method multiple times.)
 * 2. When the user presses directional keyboard keys, adds the 'is-focusVisible' classname
 *    to the document body.
 * 3. When the user clicks a mouse button, we remove the classname if it exists.
 *
 * This logic allows components on the page to conditionally render focus treatments only
 * if the global classname exists, which simplifies logic overall.
 *
 * @param window
 */
function initializeFocusRects(window) {
    var win = (window || dom_1.getWindow());
    if (win && !win.__hasInitializeFocusRects__) {
        win.__hasInitializeFocusRects__ = true;
        win.addEventListener('mousedown', _onMouseDown, true);
        win.addEventListener('keydown', _onKeyDown, true);
    }
}
exports.initializeFocusRects = initializeFocusRects;
function _onMouseDown(ev) {
    var win = dom_1.getWindow(ev.target);
    if (win) {
        var classList = win.document.body.classList;
        if (classList.contains(exports.IsFocusVisibleClassName)) {
            classList.remove(exports.IsFocusVisibleClassName);
        }
    }
}
function _onKeyDown(ev) {
    var win = dom_1.getWindow(ev.target);
    if (win) {
        var classList = win.document.body.classList;
        if (keyboard_1.isDirectionalKeyCode(ev.which) && !classList.contains(exports.IsFocusVisibleClassName)) {
            classList.add(exports.IsFocusVisibleClassName);
        }
    }
}
//# sourceMappingURL=initializeFocusRects.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uifabric/styling/~/@uifabric/utilities/lib/initializeFocusRects.js
// module id = 994
// module chunks = 0